'use string';

var moment = require( 'moment' );
var _ = require( 'lodash' );

module.exports = function detect_extreme_afk( minutes, callback, nag ) {
	var expires = moment().add( minutes, 'minutes' );
	nag = nag || false;

	var mouseMoveHandler = _.throttle( function() {
		if ( expires.isBefore( moment() ) ) {
			callback();

			if (!nag){
				window.removeEventListener( 'mousemove', mouseMoveHandler );
			}
		}
	}, 1000 * 5 );

	window.addEventListener( 'mousemove', mouseMoveHandler );
};
